export enum PropertyKind {
    House = 0,
    Apartment = 1,
    Loft = 2,
    Studio = 3,
    CommercialStore = 4,
    CommercialOffice = 5,
    Warehouse = 6,
    Land = 7,
    WoodenHouse = 8,
    Consultorios = 9,
    ComercioServicos = 10,
    Industrias = 11,
    Escolas = 12,
    Escritorios = 13,
    Hospitais = 14,
}
